<template>
  <BaseTableCollapseNested
    :headColumns="cols"
    :rows="rows"
    :pickKeys="[
      null,
      ...pickKeys
    ]"
    @onGetDetails="onGetDetails"
  />
</template>

<script>
import { digValueInObject } from '../../helpers'
import BaseTableCollapseNested from '../base/BaseTableCollapseNested'

export default {
  name: 'ReportInventoryTable',

  components: {
    BaseTableCollapseNested,
  },

  props: ['items', 'columnNames', 'pickKeys'],

  computed: {
    cols () {
      return [
        {
          style: null,
          text: this.$t('message.item'),
        },
        ...this.columnNames,
      ]
    },
    rows () {
      return this.items.map((item) => {
        const subKeys = item.skus || item.items
        return [
          {
            head: {
              text: item.date,
            },
            body: subKeys.reduce((acc, cur) => {
              return acc.push({ text: cur.info.productName, id: cur.info.skuId }) && acc
            }, []),
          },
          ...(
            (() => {
              return this.pickKeys.map((key) => {
                return {
                  head: {
                    text: this.getNumber(digValueInObject(key, item)),
                  },
                  body: subKeys.reduce((acc, cur) => {
                    return acc.push({ text: this.getNumber(digValueInObject(key, cur)) }) && acc
                  }, []),
                }
              })
            })()
          ),
        ]
      })
    },
  },

  methods: {
    onGetDetails(skuId, callback) {
      this.$emit('onGetDetails', skuId, callback)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/combine/ReportPosProductTable.vue